export function convertDecimalRateToFraction(value: number, decimals: number) {
  return Number((value / 100).toExponential(decimals + 1));
}

export function roundToTwoDecimals(num: number) {
  return parseFloat(num.toFixed(2));
}
